import { all, takeEvery, put, call } from 'redux-saga/effects'
import actions from './actions'
import { login, logout, getLoggedInUser } from '../../services/OIDCService'

// export function* LOGIN({ payload }) {
//   const { email, password } = payload
//   yield put({
//     type: 'user/SET_STATE',
//     payload: {
//       loading: true,
//     },
//   })
//   const success = yield call(login, email, password)
//   if (success) {
//     notification.success({
//       message: 'Logged In',
//       description: 'You have successfully logged in!',
//     })
//     yield put({
//       type: 'user/LOAD_CURRENT_ACCOUNT',
//     })
//   }
// }

export function LOGIN() {
  login();
  // yield put({
  //   type: 'user/LOAD_CURRENT_ACCOUNT',
  // })
}

export function* LOAD_CURRENT_ACCOUNT() {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const User = yield call(getLoggedInUser)
  if (User) {
    const response = JSON.parse(localStorage.getItem('webappuser'))
    if (response) {
      const { userid, email, username, role, accesstoken, Phone, MaterialType, IsImpersonate, RefType, TenantGuid,
        IdentityClientID, isAdmin } = response
      // const { access_token, name} = response
      yield put({
        type: 'user/SET_STATE',
        payload: {
          id: userid,
          name: username,
          email,
          avatar: '',
          role,
          authorized: true,
          accesstoken,
          Phone,
          MaterialType,
          IsImpersonate,
          reftype: RefType,
          TenantGuid,
          IdentityClientID,
          isAdmin,
        },
      })
    }
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* LOGOUT() {
  // yield call(logout)
  // localStorage.removeItem('webappuser')
  logout()
    .then(response => {
      console.log(response)
    })

  yield put({
    type: 'user/SET_STATE',
    payload: {
      id: '',
      name: '',
      role: '',
      email: '',
      avatar: '',
      accesstoken: '',
      authorized: false,
      loading: false,
      Phone: '',
      MaterialType: '',
      reftype: '',
      TenantGuid: '',
      IdentityClientID: ''
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.LOGOUT, LOGOUT),    
    LOAD_CURRENT_ACCOUNT(), // run once on app load to check user auth    
  ])
}
